<template>
  <div id="url-builder-params-grid" class="grid grid--compact">
    <ak-field class="four-twelfths">
      <ak-select
        v-model="selectedParam"
        :options="paramTypes"
        track-by="idx"
        label="name"
        placeholder="Select Type"
        group-values="opts"
        group-label="type"
      />
    </ak-field>

    <ak-field class="three-twelfths">
      <ak-input
        v-model="computedParam.key"
        :placeholder="selectedParam.name"
        :disabled="selectedParam.editable === false"
      />
    </ak-field>

    <ak-field class="four-twelfths">
      <ak-input
        v-model="computedParam.value"
        :placeholder="selectedParam.placeholder"
      />
    </ak-field>

    <div class="one-twelfth">
      <ak-button
        color="grey-lightest"
        circle
        @click.stop.prevent="removeParam(index)"
      >
        <ak-icon type="trash" color="danger" />
      </ak-button>
    </div>

    <div class="one-whole mt-tiny">
      <p class="text-small color-info mb-tiny">
        <a
          v-if="selectedParam.link"
          :href="helperUrl"
          target="_blank"
          class="color-info"
        >
          {{ selectedParam.description }}
        </a>
        <em v-if="!selectedParam.link">
          {{ selectedParam.description }}
        </em>
      </p>
    </div>
  </div>
</template>

<script>
import Input from '@akerolabs/akero-vue/src/components/input/Input.vue'
import Field from '@akerolabs/akero-vue/src/components/field/Field.vue'
import Icon from '@akerolabs/akero-vue/src/components/icon/Icon.vue'
import Button from '@akerolabs/akero-vue/src/components/button/Button.vue'
import Select from '@akerolabs/akero-vue/src/components/select/Select.vue'
import { defineComponent, computed, ref } from 'vue'
import paramTypes from './paramTypes.js'

export default defineComponent({
  name: 'AkAppsUrlBuilderRow',

  components: {
    [Input.name]: Input,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Select.name]: Select,
  },

  props: {
    param: {
      type: Object,
      default: /* istanbul ignore next */ () => ({}),
    },

    updateParam: {
      type: Function,
      default: /* istanbul ignore next */ () => {},
    },

    removeParam: {
      type: Function,
      default: /* istanbul ignore next */ () => {},
    },

    index: {
      type: Number,
      default: 0,
    },
  },

  setup(props) {
    const selected = ref({})
    const computedParam = computed(() => props.param)

    const selectedParam = computed({
      get() {
        return selected.value
      },
      set(value) {
        computedParam.value.type = value.type
        computedParam.value.key = value.value
        selected.value = value
      },
    })

    const helperUrl = computed(() => {
      // The `helpUrl` variable comes from outside the vue code, this is defined in
      // one of the last script tags in the bottom on the akero admin panel html
      return (
        helpUrl +
        (selectedParam.value && selectedParam.value.link
          ? selectedParam.value.link
          : '')
      )
    })

    return {
      computedParam,
      selectedParam,
      paramTypes,
      helperUrl,
    }
  },
})
</script>

<style lang="scss">
#url-builder-params-grid .ak-form-group-wrap {
  margin-bottom: 0;
}
</style>
